export default function Hero() {
  const handleScrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20dark%20atmospheric%20composition%20with%20warm%20crimson%20red%20and%20deep%20black%20gradient%2C%20stylized%20geometric%20shapes%20suggesting%20digital%20media%20and%20news%20feeds%2C%20subtle%20glow%20effects%20like%20distant%20city%20lights%2C%20modern%20editorial%20design%20aesthetic%2C%20dramatic%20contrast%2C%20no%20text%20or%20recognizable%20objects%2C%20cinematic%20atmosphere&width=1600&height=900&seq=hero-bg-718&orientation=landscape"
          alt="黑料718品牌主视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="w-full flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-500/90 text-background-50 mb-4">
              最新吃瓜入口 &gt;
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-3">
              黑料718 — 最新黑料吃瓜内容一站式直达平台
            </h1>

            <p className="text-base md:text-lg text-white/80 mb-2 font-heading">
              吃瓜不迷路，爆料不错过
            </p>

            <div className="mt-5 space-y-3">
              <p className="text-sm md:text-base text-white/75 leading-relaxed max-w-xl mx-auto lg:mx-0">
                黑料718作为专业吃瓜内容聚合品牌，每日追踪娱乐圈、网红圈及社会热点最新动态，为您提供黑料718网址、黑料718官网及黑料718入口直达服务。重大爆料15分钟上线，全天候滚动更新，一站解决找不到入口的烦恼。
              </p>
              <p className="text-sm md:text-base text-white/75 leading-relaxed max-w-xl mx-auto lg:mx-0">
                当前热门追踪：顶流恋情连环爆、选秀内幕调查、网红塌房实录——全站日均更新超50条，百万吃瓜群众的选择。
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mt-6">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-accent-400">50+</div>
                <div className="text-xs text-white/60 mt-1">日均更新量</div>
              </div>
              <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-accent-400">15min</div>
                <div className="text-xs text-white/60 mt-1">重大事件上线</div>
              </div>
              <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-heading text-accent-400">8大领域</div>
                <div className="text-xs text-white/60 mt-1">内容全覆盖</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-7">
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); handleScrollTo('#index'); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                探索热门专题
              </a>
              <a
                href="#updates"
                onClick={(e) => { e.preventDefault(); handleScrollTo('#updates'); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 hover:bg-white/25 text-white rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer border border-white/25"
              >
                <i className="ri-flashlight-line"></i>
                查看最新快讯
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-[280px] md:w-[380px] lg:w-[440px]">
            <div className="relative rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20modern%20editorial%20composition%20with%20layered%20geometric%20shapes%20in%20warm%20crimson%20red%20and%20dark%20amber%20tones%2C%20stylized%20magazine%20cover%20aesthetic%2C%20dynamic%20diagonal%20lines%20suggesting%20breaking%20news%20energy%2C%20dark%20background%20with%20warm%20glowing%20highlights%2C%20professional%20design%2C%20no%20recognizable%20faces%20or%20text&width=800&height=700&seq=hero-visual-718&orientation=portrait"
                alt="黑料718品牌主视觉 - 最新吃瓜内容聚合平台"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}